module.exports = __webpack_public_path__ + "img/medal6.e53c4534.png";